import { SubscriptionStats, cursor } from './state';
import { UserSubscriptionPlanSummary } from '../../UserSubscriptionPlans/constants';
import { UserSummary } from '../../Users/constants';
import { SaasSubscriptionPlanType } from './selectors';
import { Course } from '../../Courses/types';
import { SubscriptionPlanSummary } from '../../SubscriptionPlans/constants';
import { Portal } from '../../Portals/types';

export const WASABI_SAAS_FETCH_SUBSCRIPTION_STATS_SUCCESS =
  'WASABI_SAAS_FETCH_SUBSCRIPTION_STATS_SUCCESS';
export type SaasSubscriptionsFetchSubscriptionStatsSuccessAction = {
  type: 'WASABI_SAAS_FETCH_SUBSCRIPTION_STATS_SUCCESS';
  planType: SaasSubscriptionPlanType;
  stats: SubscriptionStats;
};

interface UserSummaries {
  [key: string]: UserSummary;
}

export const WASABI_SAAS_FETCH_USER_SUBSCRIPTIONS_SUCCESS =
  'WASABI_SAAS_FETCH_USER_SUBSCRIPTIONS_SUCCESS';
export type SaasSubscriptionsFetchUserSubscriptionsSuccessAction = {
  type: 'WASABI_SAAS_FETCH_USER_SUBSCRIPTIONS_SUCCESS';
  planType: 'educator' | 'personal';
  subscriptionPlans: UserSubscriptionPlanSummary[];
  users: UserSummaries;
  nextPage: cursor | null;
  previousPage: cursor | null;
};

export const WASABI_SAAS_FETCH_USER_SUBSCRIPTION_PLAN_DATA_SUCCESS =
  'WASABI_SAAS_FETCH_USER_SUBSCRIPTION_PLAN_DATA_SUCCESS';
export type SaasSubscriptionsFetchUserSubscriptionPlanDataSuccessAction = {
  type: 'WASABI_SAAS_FETCH_USER_SUBSCRIPTION_PLAN_DATA_SUCCESS';
  userSubscriptionPlan: UserSubscriptionPlanSummary;
};

export const WASABI_SAAS_FETCH_USER_SUBSCRIPTION_COURSES_START =
  'WASABI_SAAS_FETCH_USER_SUBSCRIPTION_COURSES_START';
export type SaasSubscriptionsFetchUserSubscriptionCoursesStartAction = {
  type: 'WASABI_SAAS_FETCH_USER_SUBSCRIPTION_COURSES_START';
  userSubscriptionPlanId: string;
};

export const WASABI_SAAS_FETCH_USER_SUBSCRIPTION_COURSES_SUCCESS =
  'WASABI_SAAS_FETCH_USER_SUBSCRIPTION_COURSES_SUCCESS';
export type SaasSubscriptionsFetchUserSubscriptionCoursesSuccessAction = {
  type: 'WASABI_SAAS_FETCH_USER_SUBSCRIPTION_COURSES_SUCCESS';
  userSubscriptionPlanId: string;
  courses: Course[];
};

export const WASABI_SAAS_FETCH_USER_SUBSCRIPTION_COURSES_FAILURE =
  'WASABI_SAAS_FETCH_USER_SUBSCRIPTION_COURSES_FAILURE';
export type SaasSubscriptionsFetchUserSubscriptionCoursesFailureAction = {
  type: 'WASABI_SAAS_FETCH_USER_SUBSCRIPTION_COURSES_FAILURE';
  userSubscriptionPlanId: string;
};

export const WASABI_SAAS_LIST_SUBSCRIPTION_PLANS =
  'WASABI_SAAS_LIST_SUBSCRIPTION_PLANS';
export type SassSubscriptionsListSubscriptionPlansAction = {
  type: 'WASABI_SAAS_LIST_SUBSCRIPTION_PLANS';
  plans: SubscriptionPlanSummary[];
};

export const WASABI_SAAS_LIST_PORTALS_WITHOUT_SUBSCRIPTION =
  'WASABI_SAAS_LIST_PORTALS_WITHOUT_SUBSCRIPTION';
export type SassSubscriptionsListPortalsWithoutSubscriptionAction = {
  type: 'WASABI_SAAS_LIST_PORTALS_WITHOUT_SUBSCRIPTION';
  portals: Portal[];
};

export const WASABI_SAAS_CREATE_USER_SUBSCRIPTION =
  'WASABI_SAAS_CREATE_USER_SUBSCRIPTION';
export type SaasSubscriptionsCreateUserSubscription = {
  type: 'WASABI_SAAS_CREATE_USER_SUBSCRIPTION';
  userSubscription: string;
};

export const WASABI_SAAS_CREATE_USER_SUBSCRIPTION_ERROR =
  'WASABI_SAAS_CREATE_USER_SUBSCRIPTION_ERROR';
export type SaasSubscriptionsCreateUserSubscriptionError = {
  type: 'WASABI_SAAS_CREATE_USER_SUBSCRIPTION_ERROR';
  message: string;
};

export const WASABI_SAAS_CREATE_UPDATE_DATA_LOADED =
  'WASABI_SAAS_CREATE_UPDATE_DATA_LOADED';
export type SaasSubscriptionsCreateUpdateSubscriptionDataLoaded = {
  type: 'WASABI_SAAS_CREATE_UPDATE_DATA_LOADED';
};

export const WASABI_SAAS_UPDATE_USER_SUBSCRIPTION_ERROR =
  'WASABI_SAAS_UPDATE_USER_SUBSCRIPTION_ERROR';
export type SaasSubscriptionsUpdateUserSubscriptionError = {
  type: 'WASABI_SAAS_UPDATE_USER_SUBSCRIPTION_ERROR';
  message: string;
};

export type WasabiSaasSubscriptionsAction =
  | SaasSubscriptionsFetchSubscriptionStatsSuccessAction
  | SaasSubscriptionsFetchUserSubscriptionsSuccessAction
  | SaasSubscriptionsFetchUserSubscriptionPlanDataSuccessAction
  | SaasSubscriptionsFetchUserSubscriptionCoursesStartAction
  | SaasSubscriptionsFetchUserSubscriptionCoursesSuccessAction
  | SaasSubscriptionsFetchUserSubscriptionCoursesFailureAction
  | SassSubscriptionsListSubscriptionPlansAction
  | SassSubscriptionsListPortalsWithoutSubscriptionAction
  | SaasSubscriptionsCreateUserSubscription
  | SaasSubscriptionsCreateUserSubscriptionError
  | SaasSubscriptionsCreateUpdateSubscriptionDataLoaded
  | SaasSubscriptionsUpdateUserSubscriptionError;
